export default "__VITE_ASSET__BXyDoAvR__"